import type React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Control, DropdownMenu } from '@vlabs/uikit';
import type { WithClassNameProp } from '@vlabs/uikit/types';

import { ANALYTICS_TYPES } from './analytics';
import { AnalyticsTypeMenuItem } from './AnalyticsTypeMenuItem';

interface AnalyticsTypeDropdownProps extends WithClassNameProp {
  /** Текст кнопки («Добавить»). */
  addLabel: string;
  onAdd: (type: string) => void;
  disabled?: boolean;
  /** Выравнивание меню относительно кнопки (по умолчанию — по левому краю). */
  align?: 'start' | 'end';
  'data-testid'?: string;
}

/** Кнопка «Добавить» с дропдауном типов ВА — общая для навигации группы и форм создания. */
function AnalyticsTypeDropdown({
  addLabel,
  onAdd,
  disabled = false,
  align = 'start',
  className,
  'data-testid': dataTestId = undefined,
}: AnalyticsTypeDropdownProps): React.JSX.Element {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        render={(
          <Control.Button
            className={className}
            data-testid={dataTestId}
            disabled={disabled}
            icon={<PlusIcon />}
            kind="primary"
            size="small"
            variant="flat"
          >
            {addLabel}
          </Control.Button>
        )}
      />
      <DropdownMenu.Portal>
        <DropdownMenu.Positioner
          align={align}
          style={{ zIndex: 60 }}
        >
          <DropdownMenu.Popup>
            {ANALYTICS_TYPES.map((type) => (
              <AnalyticsTypeMenuItem
                key={type.value}
                onClick={onAdd}
                type={type}
              />
            ))}
          </DropdownMenu.Popup>
        </DropdownMenu.Positioner>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

export { AnalyticsTypeDropdown };
